import React from 'react'
import { TermsOfUseLink } from 'components/TermsOfUseLink'
import badgeImg from 'assets/images/sprite/badge.svg'
import { useTranslation } from 'react-i18next'
import { StyledMoneyBackGuarantee as S } from './MoneyBackGuarantee.styles'

export const MoneyBackGuarantee: React.FC = () => {
  const { t } = useTranslation()

  return (
    <S.Wrapper>
      <S.Content>
        <S.Title>{t('purchase2.moneyBackGuarantee.title')}</S.Title>
        <S.Badge svg={badgeImg} width={64} />
        <S.Text>
          {t('purchase2.moneyBackGuarantee.text')} <TermsOfUseLink />
        </S.Text>
      </S.Content>
    </S.Wrapper>
  )
}
